import { render, staticRenderFns } from "./WaysToPay.vue?vue&type=template&id=2a1a1e3e&scoped=true"
import script from "./WaysToPay.vue?vue&type=script&lang=js"
export * from "./WaysToPay.vue?vue&type=script&lang=js"
import style0 from "./WaysToPay.vue?vue&type=style&index=0&id=2a1a1e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a1e3e",
  null
  
)

export default component.exports